export const patientsPage = {
  engagementTime: {
    pageTimeLabel: 'Patient Page Time (not billable)',
    careTimeLabel: 'Care Time',
    thisMonthHint: 'this month',
    updatedAt: (time: string) => `updated ${time}`,
    openBreakdownTooltip: 'See time by pharmacy and by user',
    title: (month: string) => `Time on this patient · ${month}`,
    byPharmacy: 'By pharmacy',
    byUser: 'By user',
    columns: {
      pharmacy: 'Pharmacy',
      user: 'User',
      role: 'Role',
      pageTime: 'Page (not billable)',
      careTime: 'Care'
    },
    currentPharmacy: 'Your pharmacy',
    activeNow: 'On this patient now',
    observer: 'Observer',
    noUsers: 'No time logged on this patient this month',
    loadError: 'Unable to load engagement time',
    pageTimeFootnote:
      "Page time counts while this patient is open in the window you're using and you've clicked, typed or scrolled in the last 2 minutes. Not billable.",
    careTimeFootnote: 'Care time is billable Monthly Care Management time, the same figure billing uses.'
  },
  sharedColumns: {
    starred: 'Starred',
    patientName: 'Patient Name',
    dob: 'DOB',
    phoneNumber: 'Phone Number',
    programs: 'Programs'
  },
  sharedMessages: {
    noRecordsFoundMessage: 'No Records Found',
    patientDetailsRetrievedMessage: 'Patient details retrieved',
    unableToRetrieveCalendarEventMessage: 'Unable to retrieve calendar event details',
    unableToRetrieveCustomerDataMessage: 'Unable to retrieve all of the customer data',
    tagPatientTooltip: 'Tag Patient'
  },
  listToolbar: {
    onboardedOnLabel: 'Onboarded On',
    organizationLabel: 'Organization',
    selectOptionPlaceholder: 'Select an option...'
  },
  dataFilter: {
    patientLookupLabel: 'Patient Lookup',
    organizationLabel: 'Organization',
    selectOptionPlaceholder: 'Select an option...',
    locationLabel: 'Location',
    followUpOnLabel: 'Follow Up On',
    followUpDateLabel: 'Follow-up Date (on or after)'
  },
  patientsList: {
    columns: {
      name: 'Name',
      profile: 'Profile',
      healthPlan: 'Health Plan',
      assignedTo: 'Assigned To',
      numberOfMeds: 'Number of Meds',
      lastEncounter: 'Last Encounter'
    },
    detailsLabel: 'Details',
    tasksLabel: 'Tasks',
    profileLabel: 'Profile',
    filterSavedMessage: 'Filter Saved',
    filterSaveErrorMessage: 'Unable to save filter',
    fetchErrorMessage: 'Unable to retrieve patients list'
  },
  medHistoryRequests: {
    scheduledTab: 'Scheduled',
    requestsSentTab: 'Requests Sent',
    medsReceivedTab: 'Meds Received',
    fetchErrorMessage: 'Failed to retrieve medication history requests',
    pendingChip: 'PENDING',
    columns: {
      patientName: 'Patient Name',
      dateOfBirth: 'Date of Birth',
      scheduledBy: 'Scheduled By',
      scheduledOn: 'Scheduled On',
      requestSentOn: 'Request Sent On',
      medsReceivedOn: 'Meds Received On',
      numberOfPatients: 'Number of Patients',
      numberOfMeds: 'Number of Meds',
      responseFileStatus: 'Response File Status',
      status: 'Status'
    }
  },
  generatedInsights: {
    summaryTitle: 'Summary',
    medicationsTitle: 'Medications',
    doseLabel: 'Dose',
    frequencyLabel: 'Frequency',
    routeLabel: 'Route',
    endedLabel: 'Ended',
    conditionsTitle: 'Conditions',
    diagnosisDateLabel: 'Diagnosis Date',
    statusLabel: 'Status',
    proceduresTitle: 'Procedures',
    dateLabel: 'Date',
    notesLabel: 'Notes',
    providerVisitsTitle: 'Provider Visits',
    drugConditionInteractionsTitle: 'Drug Condition Interactions',
    drugFoodInteractionsTitle: 'Drug Food Interactions',
    drugDrugInteractionsTitle: 'Drug Drug Interactions'
  },
  infoDrawer: {
    followUpNotFoundMessage: 'Cannot update follow-up since the follow-up could not be found.',
    deleteFollowUpTitle: 'Delete Follow-up',
    detailLabel: 'Detail',
    truentityIdLabel: 'Truentity Id',
    dateOfBirthLabel: 'Date of Birth',
    phoneLabel: 'Phone',
    locationLabel: 'Location',
    genderLabel: 'Gender',
    currentMedsLabel: 'Current Meds',
    newUploadsLabel: 'New Uploads',
    lastImportDateLabel: 'Last Import Date',
    pendingTasksLabel: 'Pending Tasks',
    completedTasksLabel: 'Completed Tasks',
    lastEncounterOnLabel: 'Last Encounter On',
    followUpDateLabel: 'Follow-up Date',
    followUpTimeLabel: 'Follow-up Time',
    followUpTypeLabel: 'Follow-up Type',
    followUpSubTypeLabel: 'Follow-up Sub Type',
    followUpStatusLabel: 'Follow-up Status',
    assignedToLabel: 'Assigned To'
  },
  patients: {
    notAllowedMessage: 'Request not allowed, logging out',
    genericErrorMessage: 'An error has occured',
    reloadErrorMessage: 'Unable to reload patients',
    searchRequiredMessage: 'One of the First Name, Last Name, Phone Number and Date of Birth is required',
    unableToRetrievePatientsMessage: 'Unable to retrieve patients',
    unableToGetRpmPatientsMessage: 'Unable to get RPM patients',
    unableToGetPatientsMessage: 'Unable to get patients',
    filterLabel: 'Filter',
    globalLookupLabel: 'Global Lookup',
    calendarTabLabel: 'Calendar',
    listTabLabel: 'List'
  },
  tagsFilterPopover: {
    searchTagsPlaceholder: 'Search tags...'
  },
  tagsPopover: {
    tagsRefreshedMessage: 'Tags refreshed successfully',
    tagsRefreshFailedMessage: 'Failed to refresh tags',
    searchTagsPlaceholder: 'Search tags...',
    tagNameLabel: 'Tag Name',
    enterTagNamePlaceholder: 'Enter tag name...'
  },
  patientInsights: {
    truentityGptLabel: 'TruentityGPT',
    keepTooltip: 'Keep',
    resetTooltip: 'Reset',
    summarizeLabel: 'Summarize'
  },
  listNavigation: {
    backToList: 'Patients list',
    backToListTooltip: 'Back to the filtered list',
    position: (position: number, total: number) => `${position} of ${total}`,
    previousTooltip: (name?: string) => `${name ? `Previous: ${name}` : 'Previous patient'} (Alt+←)`,
    nextTooltip: (name?: string) => `${name ? `Next: ${name}` : 'Next patient'} (Alt+→)`,
    previousAriaLabel: 'Previous patient in list',
    nextAriaLabel: 'Next patient in list'
  }
} as const;
